var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured_on"},[_c('h3',{staticClass:"f-19 fw-demi-bold ls-1"},[_vm._v("As featured on")]),_vm._v(" "),_c('ul',{staticClass:"mt-5"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b0e71f","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WidgetFeaturedOn.vue
// module id = 125
// module chunks = 0